import { useState } from "react";
import { toast } from "sonner";
import { Calculator } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Field, GlassCard, GradButton } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import { sayi, trTarih } from "@/components/kalip/Tablo";
import api, { errMsg } from "@/lib/api";

const Kutu = ({ l, v, testid, vurgu }) => <div className={`rounded-xl p-3 ${vurgu ? "grad-border bg-white/[0.06]" : "bg-white/[0.03]"}`}><div className="text-[11px] text-muted-foreground">{l}</div><div className="font-semibold mt-0.5" data-testid={testid}>{v}</div></div>;

export const TerminSonuc = ({ t }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4" data-testid="termin-sonuc">
    <Kutu vurgu l="Tahmini termin" v={trTarih(t.tarih)} testid="termin-tarih" />
    <Kutu l="İş günü" v={t.gun} testid="termin-gun" />
    {t.yontem === "kalip" ? <>
      <Kutu l="Üretime başlama" v={trTarih(t.baslangic)} testid="termin-baslangic" />
      <Kutu l="Darboğaz" v={t.darbogaz === "kazan" ? `Kazan (${t.kazan_ad || ""})` : "Kalıp"} testid="termin-darbogaz" />
      <Kutu l="Günlük kapasite" v={`${sayi(t.gunluk_kapasite)} adet`} testid="termin-kapasite" />
      <Kutu l="Kalıp kuyruğu" v={`${sayi(t.kuyruk_gun)} gün`} testid="termin-kuyruk" />
      {t.kazan_ad && <Kutu l="Kazan kuyruğu" v={`${sayi(t.kazan_kuyruk_gun)} gün`} testid="termin-kazan-kuyruk" />}
      <Kutu l="Bu iş" v={`${sayi(t.bu_gun, 2)} gün (kalıp)${t.kazan_ad ? ` · ${sayi(t.kazan_bu_gun, 2)} gün (kazan)` : ""}`} testid="termin-bu" />
    </> : <div className={`col-span-2 text-xs self-center ${t.uyari ? "text-amber-300" : "text-muted-foreground"}`} data-testid="termin-varsayilan">{t.uyari || "Ürüne kalıp bağlanmadığı için varsayılan teslim süresi kullanıldı."}</div>}
    {t.turetim && <div className="col-span-2 md:col-span-4 text-xs text-muted-foreground" data-testid="termin-turetim">{sayi(t.turetim.hedef_miktar)} adet için {t.turetim.miktar} adet <b>{t.turetim.kod}</b> üretilecek (1 hamdan {t.turetim.adet} adet).</div>}
  </div>
);

export const TerminHesap = ({ urunId, urunler }) => {
  const [uid, setUid] = useState(urunId || "");
  const [miktar, setMiktar] = useState(100);
  const [t, setT] = useState(null);
  const hesapla = async () => {
    if (!uid || !(Number(miktar) > 0)) return toast.error("Ürün ve miktar girin");
    try { setT((await api.post("/termin/hesapla", { urun_id: uid, miktar: Number(miktar) })).data); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <GlassCard className="p-5" data-testid="termin-hesap">
      <div className="font-semibold mb-1">Termin hesapla</div>
      <p className="text-xs text-muted-foreground mb-4">Açık üretim kuyruğu, kalıp durumu, kazan kapasitesi ve çalışma takvimi dikkate alınır.</p>
      <div className="flex flex-wrap items-end gap-3">
        {urunler && <Field label="Ürün" className="min-w-[260px] flex-1"><SelectBox urun testid="termin-urun" value={uid} onChange={setUid} options={urunler.map((u) => ({ value: u.id, label: `${u.kod} — ${u.ad}` }))} /></Field>}
        <Field label="Miktar"><Input data-testid="termin-miktar" type="number" className="bg-white/5 w-32" value={miktar} onChange={(e) => setMiktar(e.target.value)} /></Field>
        <GradButton data-testid="termin-hesapla" onClick={hesapla}><Calculator className="w-4 h-4" />Hesapla</GradButton>
      </div>
      {t && <TerminSonuc t={t} />}
    </GlassCard>
  );
};
